export class CurrentTabPageStorageWrapper {

    public static signalRChannelId: string;

    


}